import React, { useState } from 'react'
import { Tabs, Tab } from '@material-ui/core';
import { ApplicationPaymentHistory } from '../ApplicationPaymentHistory/ApplicationPaymentHistory';
import { ApplicationDetails } from '../ApplicationDetails/ApplicationDetails';
import cn from './ApplicationPreview.module.scss';

const tabs = {
  APPLICATION_DETAILS: 0,
  PAYMENT_HISTORY: 1,
};

export function ApplicationPreview({ application, editable, insuranceAgencies, serviceAgencies, handleEdit }) {
  const [tab, setTab] = useState(tabs.APPLICATION_DETAILS);

  function handleTabChange(event, value) {
    setTab(value);
  }

  return (
    <div className={cn.preview}>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        variant="fullWidth"
        indicatorColor="primary"
      >
        <Tab value={tabs.APPLICATION_DETAILS} label="Details" />
        <Tab value={tabs.PAYMENT_HISTORY} label="Payments" />
      </Tabs>
      {tab === tabs.APPLICATION_DETAILS && (
        <ApplicationDetails
          application={application}
          editable={editable}
          insuranceAgencies={insuranceAgencies}
          serviceAgencies={serviceAgencies}
          handleEdit={handleEdit}
        />
      )}
      {tab === tabs.PAYMENT_HISTORY && (
        <ApplicationPaymentHistory applicationId={application.id} />
      )}
    </div>
  );
}
